import styled from 'styled-components';

import { colorsPalettes, setFontVariant } from '@similarweb/styles';

export const StyledInsightsViewContainer = styled.div`
  padding: 16px 24px 40px 24px;
  display: flex;
  flex-direction: column;
`;

export const StyledInsightsSubHeading = styled.span`
  ${setFontVariant('report', colorsPalettes.carbon[300])};
  margin: 16px 0 14px;
`;
